<template>
  <div>
    <div v-on:click.self="close()" v-bind:style="theStyle" class="modal fade" v-bind:class="theStyleClass" tabindex="-1"
         role="dialog">
      <div class="modal-dialog" v-bind:class="modalDialogClass" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">{{ title }}</h4>
            <button type="button" v-on:click.prevent="close()" class="btn-close"></button>
          </div>
          <div class="modal-body">
            <slot></slot>
          </div>
          <div v-if="footer" class="modal-footer">
            <slot name="footer"></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "modal",
  props: ["open", "title", "closeLabel", "size"],
  data: function () {
    return {
      theStyle: "display: none;",
      theStyleClass: "",
      backdrop: null
    }
  },
  computed: {
    modalDialogClass: function () {
      switch (this.size) {
        case "sm":
          return "modal-sm";
        case "lg":
          return "modal-lg";
        case "xl":
          return "modal-xl";
        default:
          return ""
      }
    },
    footer: function () {
      return !!this.$slots.footer
    }
  },
  created: function () {
    document.addEventListener("keydown", (event) => {
      if (event.keyCode == 27) {
        this.close();
      }
    })
  },
  watch: {
    open: function (newValue/*, oldValue*/) {
      if (newValue == true) {
        this.openModal();
      } else {
        this.closeModal();
      }
    }
  },
  methods: {
    openModal: function () {
      document.body.classList.add("modal-open");
      this.backdrop = document.createElement("div");
      this.backdrop.classList.add("modal-backdrop", "fade");
      document.body.appendChild(this.backdrop);
      this.theStyle = "display: block";
      setTimeout(() => {
        this.backdrop.classList.add("show");
        this.theStyleClass = "show";
      }, 0);
    },
    closeModal: function () {
      this.theStyleClass = "";
      this.backdrop.classList.remove("show");
      // this.backdrop.style.display = "0"; // possible, but poor ie11 (blackness) fix
      setTimeout(() => {
        document.body.classList.remove("modal-open");
        if (this.backdrop != null) {
          document.body.removeChild(this.backdrop);
          this.backdrop = null;
        }
        this.theStyle = "display: none";
      }, 150) // .15s is the animation length of the 'fade' style class
    },
    close: function () {
      this.$emit("close")
    }
  }
}
</script>
